export interface Authentication {
  accessToken: string;
  idToken: string;

  /**
   * refreshToken only for iOS and Android
   */
  refreshToken?: string;
  expiresIn?: string;
}

export interface User {
  id: string;
  email: string;
  name: string;
  familyName: string;
  givenName: string;
  imageUrl: string;
  serverAuthCode: string;
  authentication: Authentication;
  isImap?: boolean;
  password?: string;
  desc?: string;
  hostname?: string;
  useSSL: boolean;
  useTLS: boolean;
  loginFor: LoginFor;
}
export enum LoginFor {
  email = "email",
  gDrive = "g-drive",
}
